<div class="img-wrapper">
  <div class="close-button" (click)="closeDialog()">
    <fa-icon class="profile-no-image" icon="times"></fa-icon>
  </div>
  <img src="{{ data.imageUrl }}" />
</div>
